import { useEffect, useState } from 'react';

import { FormikProps } from 'formik';

import FilledFilter from '@pharmaplan/common/assets/icons/searchIconGreen.svg';
import UnfilledFilter from '@pharmaplan/common/assets/icons/searchIcon.svg';

import {
  AdditionalReports,
  getTypeOfUser,
  PharmacyReportTypes,
  ReportRequestTypes,
  TypeOfUser,
} from '@pharmaplan/common';

import CloseFilter from '../assets/svg/close.svg';
import { useAppSelector } from './useAppSelector';
import useSelfService from './useSelfService';

const { booked, workshift, watchlist, requested } = ReportRequestTypes;
const { bookingReport } = PharmacyReportTypes;
const { replacements } = AdditionalReports;

const showFilterCriteria = new Set([
  booked,
  workshift,
  watchlist,
  requested,
  replacements,
  bookingReport,
]);

const useExpandableFilter = (
  formik: FormikProps<any>,
  isFiltered: boolean,
  type: any,
) => {
  const userType = useAppSelector(getTypeOfUser);
  const isPharmacy = userType === TypeOfUser.pharmacy;
  const isPharmacist = userType === TypeOfUser.pharmacist;
  const { isSelfService } = useSelfService();

  const showFilterIcon = (isSelfService && isPharmacist) || (!isSelfService && isPharmacy);
  const [showFilter, setShowFilter] = useState(false);

  useEffect(() => {
    setShowFilter(showFilterIcon && showFilterCriteria.has(type));
  }, [showFilterIcon, type]);

  // eslint-disable-next-line consistent-return
  const filterStates = () => {
    switch (true) {
      case !isFiltered && !showFilter:
        return {
          icon: UnfilledFilter,
          onClick: () => {
            setShowFilter((prev) =>
              !prev);
          },
        };
      case !isFiltered && showFilter:
        return {
          icon: CloseFilter,
          onClick: () => {
            setShowFilter((prev) =>
              !prev);
            formik.resetForm();
          },
        };
      case isFiltered:
        return {
          icon: FilledFilter,
          onClick: () =>
            setShowFilter((prev) =>
              !prev),
        };
      default:
        break;
    }
  };

  return { filterStates, setShowFilter, showFilter, showFilterIcon };
};

export default useExpandableFilter;
